import { meetsPartnerCriteria } from '@/utils/partner-eligibility.js';

const EMPLOYED_STATUSES = ["full_time", "part_time", "self_employed", "gig_worker"];
const SELF_EMPLOYED_STATUSES = ["self_employed", "gig_worker"];
const AUTH_CONSENT_OPTIONS = ["1", "2"];
// Ownership share is not asked for these structures: a sole proprietor owns 100% (lms derives it),
// a non-profit has no owner.
const OWNERSHIP_IMPLIED_STRUCTURES = ["sole_proprietorship", "non_profit"];
const PARTNERSHIP_STRUCTURES = ["general_partnership", "limited_partnership"];
// Credit situations where asking about a trustee/credit counsellor makes sense: "good" makes it
// unlikely, and bankruptcy / consumer proposal imply one (both are filed through a trustee).
const TRUSTEE_QUESTION_CREDIT_SITUATIONS = ["fair", "low", "unknown"];

// Every helper answers "should this step/field be HIDDEN?".
const fieldConditionHelper =  {
    employment: (app) => !app.income_type || !EMPLOYED_STATUSES.includes(app.income_type),
    isSelfEmployment: (app) => !app.income_type || SELF_EMPLOYED_STATUSES.includes(app.income_type),
    homeOwner: (app) => !app.own_home || app.own_home === "no",
    // Owners who chose "No mortgage, it's paid off" on the rent/mortgage step: the balance is known
    // to be zero, so the mortgage field is hidden and the server sends property_mortgage = 0.
    noMortgage: (app) => app.own_home === "yes" && String(app.rent_mortgage_payment) === "0",
    accountCreation: (app) => app.wants_to_create_account !== "yes",
    // Server-side kill switch (MEMBER_ACCOUNT_CREATION_ENABLED). Only an explicit false hides the step, so a
    // page that doesn't inject the flag keeps the step on.
    memberAccountCreationDisabled: () => typeof window !== 'undefined' && window.App?.member_account_creation_enabled === false,
    retryLogin: (app) => app.wrong_password_decision !== "retry_login",
    resetPassword: (app) => {
        return (app.wants_to_reset_password && app.wants_to_reset_password !== "yes") ||
            (app.wrong_password_decision && app.wrong_password_decision !== "reset_password");
    },
    hasAuthConsent: (app) => !!app.credit_auth && AUTH_CONSENT_OPTIONS.includes(app.credit_auth),
    meetsSkcpConditions: (app) => {
        const hasRequiredFields = app.direct_deposit &&
            app.address && app.address.province &&
            app.income_type &&
            app.monthly_income &&
            app.direct_deposit === 'yes' &&
            app.monthly_income >= 1500 &&
            app.completed_flinks && app.completed_flinks === 'yes';

        if (!hasRequiredFields) {
            return true;
        }

        return !meetsPartnerCriteria('skcp', app);
    },
    // Business products. `product_name` is the canonical product (aliases already resolved).
    notMca: (app) => app.product_name !== 'mca',
    notOntario: (app) => !app.address || app.address.province !== 'ON',
    ownershipImplied: (app) => OWNERSHIP_IMPLIED_STRUCTURES.includes(app.business_structure),
    // Hide the trustee question unless the applicant is in Ontario with fair/low/unknown credit.
    skipTrusteeQuestion: (app) => fieldConditionHelper.notOntario(app)
        || !TRUSTEE_QUESTION_CREDIT_SITUATIONS.includes(app.in_credit_situation),
    // Not a hide rule: used to drop the "only owner" choice for partnerships.
    isPartnership: (app) => PARTNERSHIP_STRUCTURES.includes(app.business_structure),
}

export { fieldConditionHelper }
